// Swiper Import from npm package

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, EffectCoverflow } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';

const swiperHero = document.querySelector('.hero-section .swiper');
if (swiperHero) {
    new Swiper('.hero-section .swiper', {
        modules: [Autoplay, EffectFade],
        loop: false,
        grabCursor: false,
        effect: 'fade',
        slidesPerView: 1,
        fadeEffect: {
            crossFade: true,
        },
        speed: 2000,
        autoplay: true,
        allowTouchMove: false,
    });
}

/**
 * Team Section Slider
 */

const swiperTeam = document.querySelectorAll('.about-team.swiper');
if (swiperTeam) {
    new Swiper('.about-team', {
        modules: [Navigation],
        loop: false,
        grabCursor: true,
        slidesPerView: 3.25,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-btn-next-team',
            prevEl: '.swiper-btn-prev-team',
        },
        breakpoints: {
            100: {
                spaceBetween: 20,
                slidesPerView: 1.25,
            },
            1024: {
                spaceBetween: 20,
                slidesPerView: 2.25,
            },
            1440: {
                spaceBetween: 50,
                slidesPerView: 3.25,
            },
        },
    });
}

/**
 * News Section Slider
 */

const swiperNews = document.querySelectorAll('.news.swiper');
if (swiperNews) {
    new Swiper('.news', {
        modules: [Navigation],
        loop: false,
        grabCursor: true,
        slidesPerView: 3.25,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-btn-next-news',
            prevEl: '.swiper-btn-prev-news',
        },
        breakpoints: {
            100: {
                spaceBetween: 20,
                slidesPerView: 1.25,
            },
            1024: {
                spaceBetween: 20,
                slidesPerView: 2.25,
            },
            1440: {
                spaceBetween: 50,
                slidesPerView: 3.25,
            },
        },
    });
}

const swiperHistories = document.querySelectorAll('.history-slider.swiper');
if (swiperHistories.length > 0) {
    const slider = new Swiper('.history-slider', {
        modules: [Navigation, EffectCoverflow],
        effect: 'coverflow',
        grabCursor: false,
        allowTouchMove: false,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: false,
        slidesPerView: 2.47,
        coverflowEffect: {
            rotate: 0,
            stretch: 80,
            depth: 200,
            modifier: 2,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.swiper-btn-next-history',
            prevEl: '.swiper-btn-prev-history',
        },
        runCallbacksOnInit: true,
        speed: 600,
        breakpoints: {
            320: {
                slidesPerView: 1,
                coverflowEffect: {
                    stretch: 5,
                    depth: 300,
                },
            },
            1025: {
                slidesPerView: 1.8,
                coverflowEffect: {
                    stretch: 80,
                    depth: 200,
                },
            },
            1281: {
                slidesPerView: 2.47,
                coverflowEffect: {
                    stretch: 80,
                    depth: 200,
                },
            },
        },
        on: {
            setTranslate: function (swiper) {
                setMatrix(swiper);
                swiper.slides.forEach((el) => {
                    if (!el.classList.contains('slide-animation')) {
                        el.classList.add('slide-animation');
                    }
                });
            },
            slideChange: function () {
                setMatrix(this);
            },
        },
    });

    function setMatrix(swiper, direction = null) {
        const slides = swiper.slides;
        let activeIndex = swiper.activeIndex;

        if (direction === 'next' && activeIndex < slides.length - 1) {
            activeIndex = activeIndex + 1;
        } else if (direction === 'prev' && activeIndex > 0) {
            activeIndex = activeIndex - 1;
        }

        slides.forEach((slide, i) => {
            const offset = i - activeIndex;
            slide.setAttribute('data-slide', offset);

            const transform = slide.style.transform;

            if (transform && transform !== 'none') {
                let newTransform;
                let slideCard = slide.querySelector('.slide-card');
                if (offset === 0) {
                    slideCard.style.opacity = '1';
                    newTransform = transform.replace(/translate3d\(([^,]+),\s*[^,]+,\s*([^)]+)\)/, `translate3d($1, 0px, $2)`);
                } else if (offset > 0) {
                    slideCard.style.opacity = '1';
                    newTransform = transform.replace(/translate3d\(([^,]+),\s*[^,]+,\s*([^)]+)\)/, `translate3d($1, -${offset * 40}%, $2)`);
                } else if (offset < 0) {
                    slideCard.style.opacity = '0';
                    newTransform = transform.replace(/translate3d\(([^,]+),\s*[^,]+,\s*([^)]+)\)/, `translate3d($1, ${Math.abs(offset) * 40}%, $2)`);
                }

                slide.style.transform = newTransform;
            }
        });
    }
}

const swiperMembers = document.querySelectorAll('.member-slider.swiper');
if (swiperMembers.length > 0) {
    const memberSlider = new Swiper('.member-slider', {
        modules: [Navigation],
        effect: 'coverflow',
        grabCursor: true,
        allowTouchMove: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: false,
        slidesPerView: 1.7,
        initialSlide: 1,
        navigation: {
            nextEl: '.swiper-btn-next-member',
            prevEl: '.swiper-btn-prev-member',
        },

        runCallbacksOnInit: true,
        speed: 600,
        breakpoints: {
            320: {
                slidesPerView: 1.7,
                spaceBetween: 40,
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 80,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 135,
            },
            1441: {
                slidesPerView: 3,
                spaceBetween: 200,
            },
            1921: {
                slidesPerView: 3,
                spaceBetween: 135,
            },
        },
    });
}

const swiperTestimonials = document.querySelectorAll('.testimonials-swiper.swiper');
if (swiperTestimonials.length > 0) {
    const testimonialsSwiper = new Swiper('.testimonials-swiper', {
        modules: [Navigation, EffectCoverflow],
        effect: 'coverflow',
        grabCursor: true,
        allowTouchMove: true,
        initialSlide: 1,
        centeredSlides: true,
        loop: false,
        slidesPerView: 1,
        coverflowEffect: {
            rotate: 0,
            stretch: 80,
            depth: 200,
            modifier: 2,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.swiper-btn-next-testimonials',
            prevEl: '.swiper-btn-prev-testimonials',
        },
        runCallbacksOnInit: true,
        speed: 600,
        breakpoints: {
            320: {
                coverflowEffect: {
                    stretch: 40,
                    depth: 150,
                },
            },
            1025: {
                coverflowEffect: {
                    stretch: 82,
                    depth: 650,
                },
            },
        },
    });
}
